import { render } from "./Loading.vue?vue&type=template&id=5b047486"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=5b047486&lang=scss"
script.render = render

export default script